import React from 'react';

import SvgContainer from '../SvgContainer';

const FiveLevelFive = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100973)">
                <path d="M6.85714 6.49993C6.85714 5.94764 7.36882 5.49993 8 5.49993C8.63118 5.49993 9.14286 5.94764 9.14286 6.49993V15C9.14286 15.5522 8.63118 16 8 16C7.36882 16 6.85714 15.5522 6.85714 15V6.49993Z" />
                <path d="M10.2857 3.5C10.2857 2.94772 10.7974 2.5 11.4286 2.5C12.0598 2.5 12.5714 2.94772 12.5714 3.5V15C12.5714 15.5522 12.0598 16 11.4286 16C10.7974 16 10.2857 15.5522 10.2857 15V3.5Z" />
                <path d="M13.7143 0.999997C13.7143 0.447713 14.226 0 14.8571 0C15.4883 0 16 0.447713 16 0.999997V15C16 15.5522 15.4883 16 14.8571 16C14.226 16 13.7143 15.5522 13.7143 15V0.999997Z" />
                <path d="M3.42857 9.49999C3.42857 8.9477 3.94025 8.49999 4.57143 8.49999C5.20261 8.49999 5.71429 8.9477 5.71429 9.49999V15C5.71429 15.5523 5.20261 16 4.57143 16C3.94025 16 3.42857 15.5523 3.42857 15V9.49999Z" />
                <path d="M0 12C0 11.4477 0.511675 11 1.14286 11C1.77404 11 2.28571 11.4477 2.28571 12V15C2.28571 15.5523 1.77404 16 1.14286 16C0.511675 16 0 15.5523 0 15V12Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100973">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default FiveLevelFive;
